module.exports = __webpack_public_path__ + "static/media/iphonex_splash.fae4e81a.png";